import VerifyOtpComponent from "../../components/auth/verify-otp"

const VerifyOtp = () => {
  return (
    <div>
      <VerifyOtpComponent />
    </div>
  )
}

export default VerifyOtp
